import urls from 'urls';
import {removeClass, addClass, hasClass} from 'evite';
import {ModalDialog} from '../modal/index';
import {getURLParameter, valid_email} from '../common/utils';

export class RegisterLogin {
  constructor() {
    // used to not warn about missing inputs/errors when certain
    // elements are clicked on
    this.skipValidationOnBlurFor = [];

    // this only is for login form
    const registerForm = document.querySelector('form');
    const registerPageForm = document.getElementById('register_form');

    const registerButton = document.querySelector('button.register');
    const facebookAuth = document.getElementById('facebook_account_auth');
    const googlePlusAccountAuth = document.getElementById('google_plus_account_auth');
    const appleAuthButton = document.querySelector('#appleid-signin');

    const formToggle = document.getElementById('formToggle');
    const forgotPassword = document.getElementById('forgot_password');
    const togglePassword = document.getElementById('toggle_password');
    const emailField = document.getElementById('id_email');
    const confirmEmailField = document.getElementById('id_confirm_email');
    const passwordField = document.getElementById('id_password');
    const mobilepasswordField = document.getElementById('password');
    const firstNameField = document.getElementById('id_first_name');
    const lastNameField = document.getElementById('id_last_name');
    const genderField = document.getElementById('id_gender');
    this.zipCodeField = document.getElementById('id_zip_code');
    this.country = document.getElementById('id_country');
    const selfDescribeGender = document.getElementById('id_self_described_gender');
    if (registerForm) registerForm.addEventListener('submit', this.submit_handler.bind(this));
    if (registerPageForm)
      registerPageForm.addEventListener('submit', this.submit_handler.bind(this));
    if (registerButton) registerButton.addEventListener('submit', this.submit_handler);
    if (facebookAuth) facebookAuth.addEventListener('click', this.facebook_connect);
    if (googlePlusAccountAuth)
      googlePlusAccountAuth.addEventListener('click', this.google_plus_connect);
    if (forgotPassword) {
      forgotPassword.addEventListener('click', this.forgot_password);
      this.skipValidationOnBlurFor.push(forgotPassword);
    }
    if (formToggle) {
      this.skipValidationOnBlurFor.push(formToggle);
    }
    if (togglePassword) togglePassword.addEventListener('click', this.toggle_password);
    if (emailField) emailField.addEventListener('blur', this.onInputBlur);
    if (confirmEmailField) {
      this.emailField = emailField;
      confirmEmailField.addEventListener('blur', this.handling_blur_confirm_email.bind(this));
    }
    if (genderField) {
      this.gender = genderField;
      this.selfDescribeGender = selfDescribeGender;
      genderField.addEventListener('blur', this.onInputBlur);
      genderField.onchange = this.onChangeGender.bind(this);
    }
    if (selfDescribeGender) selfDescribeGender.addEventListener('blur', this.onInputBlur);

    if (passwordField) passwordField.addEventListener('blur', this.onInputBlur);
    if (mobilepasswordField) mobilepasswordField.addEventListener('blur', this.onInputBlur);
    if (firstNameField) firstNameField.addEventListener('blur', this.onInputBlur);
    if (lastNameField) lastNameField.addEventListener('blur', this.onInputBlur);
    if (this.zipCodeField) this.zipCodeField.addEventListener('blur', this.onInputBlur);
    if (this.country) this.country.addEventListener('change', this.onCountryChange);

    if (appleAuthButton) {
      appleAuthButton.addEventListener('click', this.appleConnect);
    }

    if (emailField) emailField.focus();
    this.submitting = false;

    const utm_campaign = getURLParameter('utm_campaign');
    if (utm_campaign == 'forgot_password_bt') this.forgot_password();
  }

  validateForm(e) {
    const requiredInputs = Array.from(e.target.querySelectorAll('input,select')).filter(
      (input) => input.required
    );
    const invalidInputs = requiredInputs.filter((input) => !this.validate_input(input));
    if (invalidInputs.length) {
      invalidInputs[0].focus();
      return false;
    }
    return true;
  }

  submit_handler(e) {
    if (this.submitting) {
      e.preventDefault();
      return;
    }
    if (this.validateForm(e)) {
      this.submitting = true;
      this.submit_form;
    } else {
      e.preventDefault();
    }
  }

  get submit_form() {
    return evite.debounce(() => (this.submitting = false), 1000);
  }

  facebook_connect(e) {
    e.preventDefault();
    window.evite.when('sign-in-view').then((signInView) => {
      signInView.facebook_connect({
        onConnect: () => {
          const next = getURLParameter('next');
          if (next) {
            window.parent.location = next;
          } else {
            window.location = '/';
          }
        },
      });
    });
  }

  google_plus_connect(e) {
    e.preventDefault();
    window.evite.when('sign-in-view').then((signInView) => {
      signInView.google_plus_connect({
        onConnect(param) {
          const next = getURLParameter('next');
          console.warn('google connect callback with params ', param);
          if (next) {
            console.warn('going to next ', next);
            window.parent.location.href = next;
          } else {
            window.location.href = '/';
            console.warn('going to home ');
          }
        },
      });
    });
  }

  appleConnect(e) {
    e.preventDefault();
    window.evite.when('sign-in-view').then((signInView) => {
      const onConnect = (e) => {
        console.warn('authenticated callback entered ');
        const next = getURLParameter('next');
        if (next) {
          console.warn('Go to Next ', next);

          window.parent.location = next;
        } else {
          console.warn('Go to Home');
          window.location = '/';
        }
      };
      signInView.apple_connect(onConnect);
    });
  }

  forgot_password() {
    window.forgot_modal = new ModalDialog({
      url: urls.get('forgot_modal'),
      onOpen: () => {
        const modal = document.querySelector('.eviteModalContainer');
        const emailField = modal.querySelector('#id_email_forgot');
        const emailVal = document.querySelector('#id_email').value;
        if (emailVal) {
          emailField.value = emailVal;
        }
        emailField.focus();
        return emailField;
      },
    });
    window.forgot_modal.show();
  }

  handling_error(inputField, name) {
    let errorString = '';
    if (inputField.validity.valueMissing) {
      errorString = `${name} is a required field.`;
    } else if (inputField.validity.typeMismatch || inputField.validity.patternMismatch) {
      errorString = `Invalid ${name}`;
    } else if (inputField.validity.tooShort) {
      errorString = `Your ${name} must contain at least ${inputField.attributes.minlength.value} characters.`;
    }
    return errorString;
  }

  handling_email_errors(validEmail, inputLabel) {
    let errorString = '';
    switch (validEmail.error_code) {
      case 'email_empty':
        errorString = `${inputLabel} is a required field.`;
        break;
      case 'email_invalid':
        errorString = 'Invalid Email';
        break;
    }
    return errorString;
  }

  getErrorLabel(input) {
    const errorLabel =
      // TODO? If all inputs have a common attribute value with their error-sublabel (such as aria-describedby)
      // we can use that instead and remove the <div> parents that aren't needed & render fewer dom nodes?
      input.tagName === 'SELECT'
        ? input.parentNode.parentNode.getElementsByClassName('error-text')
        : input.parentNode.getElementsByClassName('error-text');
    return errorLabel.length ? errorLabel[0] : null;
  }

  validate_confirm_email(emailInput, confirmInput) {
    const errorLabel = this.getErrorLabel(confirmInput);
    let errorMessage = '';
    let valid = this.validate_input(confirmInput);
    if (valid) {
      // if the input is valid we need to check that it match with the original email input
      if (emailInput.value !== confirmInput.value) {
        errorMessage = 'Your confirm email address must match.';
        confirmInput.classList.add('error');
        confirmInput.setAttribute('aria-invalid', true);
        valid = false;
      } else {
        confirmInput.classList.remove('error');
        confirmInput.setAttribute('aria-invalid', false);
      }
      if (errorLabel) errorLabel.innerHTML = errorMessage;
    }
    return valid;
  }

  validate_input(input) {
    // TODO: As we're adding actual visual <label>s for accessibility, we should get rid of
    // the aria-label attribute so it's not announced twice.
    const fieldName = input.hasAttribute('aria-label')
      ? input.getAttribute('aria-label')
      : input.getAttribute('name');

    const errorLabel = this.getErrorLabel(input);
    let errorMessage = '';
    let valid = true;
    if (input.type === 'email') {
      const validEmail = valid_email(input.value);
      if (!validEmail.is_valid) {
        errorMessage = this.handling_email_errors(validEmail, input.placeholder);
        input.classList.add('error');
        input.setAttribute('aria-invalid', true);
        valid = false;
      } else {
        input.classList.remove('error');
        input.setAttribute('aria-invalid', false);
      }
    } else {
      valid = input.checkValidity();
      if (fieldName === 'Zip Code' && this.country.value !== 'US') {
        // don't validate non-us zip codes
        valid = true;
      }
      if (!valid) {
        errorMessage = this.handling_error(input, fieldName);
        input.classList.add('error');
        input.setAttribute('aria-invalid', true);
      } else {
        input.classList.remove('error');
        input.removeAttribute('aria-invalid', false);
      }
    }
    if (errorLabel) errorLabel.innerHTML = errorMessage;
    return valid;
  }

  handling_blur_confirm_email(e) {
    this.validate_confirm_email(this.emailField, e.target);
  }

  onChangeGender() {
    const {value} = this.gender;
    if (value === 'O') {
      this.selfDescribeGender.required = true;
    } else {
      this.selfDescribeGender.required = false;
    }
  }

  onInputBlur = (e) => {
    if (this.shouldSkipInputValidationOnBlurFor(e)) return;

    this.validate_input(e.target);
  };

  onCountryChange = (e) => {
    this.validate_input(this.zipCodeField);
  };

  shouldSkipInputValidationOnBlurFor = (e) =>
    // don't do the input validation if the thing being clicked on
    // (causing the focus out event) is one of the things for which
    // we, uhh, don't want to do the input validation on the thing
    // losing focus
    this.skipValidationOnBlurFor.includes(e.relatedTarget);

  toggle_password(e) {
    e.preventDefault();
    const passwords = document.getElementById('passwords');
    const passwordField = document.getElementById('id_password');
    let pwType;
    if (hasClass(passwords, 'register__password--shown')) {
      removeClass(passwords, 'register__password--shown');
      pwType = 'password';
    } else {
      addClass(passwords, 'register__password--shown');
      pwType = 'text';
    }
    passwordField.setAttribute('type', pwType);
    return false;
  }
}

evite.resolve('auth/register-login', RegisterLogin);
